import { Component, HostListener } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';
import * as moment from 'moment-mini';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';

@Component({
  selector: 'project-support',
  templateUrl: './projectSupport.component.html',
  styleUrls: ['./projectSupport.component.css'],
})

export class ProjectSupportComponent {
  constructor(public permissions: PermissionsService,
    private transferHttp: TransferHttpService) {
  }

  oaProjectName = this.transferHttp.tenantConfig.projectSupport.oaProjectName;

  nonOMLink(): string {
    return `/reporting/NonOandMTimeEntry/trdp/{"From":"${moment().startOf('month').format('YYYY-MM-DD')}","To":"${moment().endOf('month').format('YYYY-MM-DD')}","WorkType":"O&A"}`;
  }


  ngOnInit() {
  }

}
